import { TABLE } from "../constant/table.constant";

const sampleFieldOptions: Record<string, string[]> = {
  empId: ["E001", "E002", "E003", "E004", "E005"],
  empName: ["Anita Sharma", "Aashish Mehra", "Sunita Rao", "Rajesh Kumar", "Neha Singh"],
  empEml: ["anita.sharma@example.com", "aashish.mehra@example.com", "sunita.rao@example.com", "rajesh.kumar@example.com", "neha.singh@example.com"],
  empPhone: ["+91-9876543210", "+91-9988776655", "+91-8877665544", "+91-7766554433", "+91-6655443322"],
  status: ["Active", "Active", "Active", "Active", "Active"],
  empTyp: ["Full time", "Part time", "Intern", "Full time", "Contract"],
  userTyp: ["Account Admin", "Manager", "User", "Account Admin", "User"],
  depart: ["Engineering", "Marketing", "Finance", "HR", "Sales"],
  designation: ["Software Engineer", "Marketing Lead", "Accounts Trainee", "HR Manager", "Sales Executive"],
  strtDt: ["2020-01-15", "2021-02-20", "2022-05-12", "2019-07-01", "2023-01-25"],
  ctc: ["₹600000", "₹500000", "₹400000", "₹700000", "₹800000"],
  reportingMngr: ["EMP100", "MB100", "DX2139", "EMP300", "EMP400"],
  panNo: ["ABCDE1234F", "ABCDE5678K", "ABCDE9012L", "ABCDE3456Z", "ABCDE7890P"],
  aadharNo: ["123456789012", "234567890123", "345678901234", "456789012345", "567890123456"],
  address: ["123 Main St, City A", "456 Elm St, City B", "789 Oak St, City C", "101 Pine St, City D", "202 Maple St, City E"],
  fb: ["fb.com/anita.sharma", "fb.com/aashish.mehra", "fb.com/sunita.rao", "fb.com/rajesh.kumar", "fb.com/neha.singh"],
  li: [
    "linkedin.com/in/anita-sharma",
    "linkedin.com/in/aashish-mehra",
    "linkedin.com/in/sunita-rao",
    "linkedin.com/in/rajesh-kumar",
    "linkedin.com/in/neha-singh",
  ],
  ig: ["instagram.com/anita.sharma", "instagram.com/aashish.mehra", "instagram.com/sunita.rao", "instagram.com/rajesh.kumar", "instagram.com/neha.singh"],
  tw: ["twitter.com/anitaS", "twitter.com/aashishM", "twitter.com/sunitaR", "twitter.com/rajeshK", "twitter.com/nehaS"],
  createdBy: ["Rahul Agarwal", "Sunita Rao", "Aashish Mehra", "Anita Sharma", "Rajesh Kumar"],
  updatedTs: ["2024-06-10 09:00:00", "2024-06-10 09:15:00", "2024-06-10 09:30:00", "2024-06-10 09:45:00", "2024-06-10 10:00:00"],
};

function generateCSV(fields: typeof TABLE.EMPLOYEE_TABLE_FIELDS, options: Record<string, string[]>, isBOMEncoding: boolean = false) {
  const numRecords = 5; // since sampleFieldOptions has 5 entries per field

  const headers = fields.map((f) => f.label);
  const rows: string[][] = [];

  for (let i = 0; i < numRecords; i++) {
    const row = fields.map((f) => options[f.id]?.[i] ?? "");
    rows.push(row);
  }

  const headerClean = (value: string) => {
    if (value.includes(",") || value.includes('"') || value.includes("\n")) {
      return `"${value.replace(/"/g, '""')}"`;
    }
    return value;
  };

  const rowClean = (value: string, disableAutoFormatting: boolean = false) => {
    if (!value) return "";

    // Prevent Excel auto-formatting for long numbers if the flag is set
    if (disableAutoFormatting) {
      value = `="${value}"`;
    }
    if (value.includes(",") || value.includes('"') || value.includes("\n")) {
      return `"${value.replace(/"/g, '""')}"`;
    }
    return value;
  };

  // Clean headers without BOM encoding
  const headersContent = headers.map(headerClean).join(",");

  // Clean rows, add BOM encoding if requested
  const rowsContent = rows
    .map((row) =>
      row
        .map((value, index) => {
          // Disable auto-formatting for 'Phone' and 'ctc' fields
          const disableAutoFormatting = fields[index]?.id === "empPhone" || fields[index]?.id === "ctc";
          return rowClean(value, disableAutoFormatting);
        })
        .join(",")
    )
    .join("\n");

  // Prepend BOM to rows content, not headers
  const csvContent = headersContent + "\n" + rowsContent + "\n";

  return isBOMEncoding ? "\uFEFF" + csvContent : csvContent;
}

export function downloadFilteredCSV(isBOMEncoding: boolean = false) {
  const filteredFields: any = [...TABLE.EMPLOYEE_TABLE_FIELDS, ...TABLE.EMPLOYEE_TABLE_HIDDEN_FIELDS].filter((field: any) => !field?.hideFromImport);

  const csv = generateCSV(filteredFields, sampleFieldOptions, isBOMEncoding);
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = "employee_sample.csv";
  a.click();

  URL.revokeObjectURL(url);
}
